import Vue from 'vue'
import Vuetify, { VApp, VMain, VContainer, VRow, VCol, VCard, VCardText, VBtn, VIcon, VImg, VSubheader } from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'

import '@/styles/main.scss'

Vue.use(Vuetify, {
    components: {
        VApp,
        VMain,
        VContainer, 
        VRow, 
        VCol, VCard, VCardText,
        VBtn, VIcon, VImg,
        VSubheader
    }
})

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#5973BA', // '#6171C2', // colors.indigo.lighten2,
                secondary: colors.blueGrey.darken4,
                accent: '#DA1884' // '#E63488' // '#E31C79' // '#EB0052' // colors.pink.accent3
            },
            dark: {
                primary: colors.indigo.lighten2,
                secondary: colors.blueGrey.darken4,
                accent: colors.pink.accent3
            }
        }
    }
})
